import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { isExternalLink } from '../../../components/AppLink';
import RoundShadowBox from '../../../components/RoundShadowBox';
import { colors } from '../../../styles/constants';
import messages from './messages';

const Container = styled(RoundShadowBox)`
  ${tw`flex flex-col p-def mb-abs4 md:flex-row`};
`;

const PictureHolder = styled.div`
  ${tw`w-full mb-def md:px-def md:mb-0`};
  max-height: 8rem;
  max-width: 20rem;
`;

const Picture = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const Infos = styled.div`
  ${tw`md:px-def w-full`};
`;

const Website = styled.a`
  ${tw`flex`};
  color: ${colors.secondary400};
  font-weight: 600;
  text-decoration: none;
`;

const CompanyHistoryCard = ({ contact, logo, name, phone, website }) => (
  <Container>
    <PictureHolder>
      <Picture src={logo} />
    </PictureHolder>
    <Infos>
      <Website href={website}>
        <FormattedMessage {...messages.website} />
        &nbsp;{name}
      </Website>
      {phone && <Phone phone={phone} />}
      {contact && <Contact contact={contact} />}
    </Infos>
  </Container>
);

const Phone = ({ phone }) =>
  phone.match(/^\+?[ \d+]+/g) ? (
    <Website href={`tel:${phone}`}>{phone}</Website>
  ) : (
    <p>{phone}</p>
  );

const Contact = ({ contact }) => {
  if (isExternalLink(contact)) {
    return <Website href={contact}>{contact}</Website>;
  }
  if (contact.includes('@')) {
    return <Website href={`mailto:${contact}`}>{contact}</Website>;
  }
  return <p>{contact}</p>;
};

Phone.propTypes = {
  phone: PropTypes.string,
};

Contact.propTypes = {
  contact: PropTypes.string,
};

CompanyHistoryCard.propTypes = {
  contact: PropTypes.string,
  logo: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  website: PropTypes.string,
};

export { CompanyHistoryCard };
